enum SizeEnum {
  SMALL = "sm",
  MEDIUM = "md",
  LARGE = "lg"
}
export default SizeEnum;
